
'use client';

import { usePathname } from 'next/navigation';
import { Suspense } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { Header } from '@/components/layout/header';
import { Footer } from '@/components/layout/footer';
import { TopLoader } from '@/components/layout/top-loader';
import AnalyticsTracker from '@/components/AnalyticsTracker';

export function ClientLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname();
  const isAdminPage = pathname.startsWith('/admin');

  return (
    <>
      <Suspense>
        <TopLoader />
        {!isAdminPage && <AnalyticsTracker />}
      </Suspense>
      <div className="relative flex min-h-screen flex-col bg-background">
        {!isAdminPage && <Header />}
        <main className="flex-1 flex flex-col">{children}</main>
        {!isAdminPage && <Footer />}
      </div>
      <Toaster />
    </>
  );
}
